<template>
  <v-layout row class="mb-2">
    <v-icon>wc</v-icon>
    <v-btn-toggle
      v-model="genderModel"
      @change="updateGender()"
      class="ml-3"
    >
      <v-btn flat :value="clientModel.mister">
        <span>{{ $t('mister') }}</span>
      </v-btn>
      <v-btn flat :value="clientModel.miss">
        <span>{{ $t('miss') }}</span>
      </v-btn>
    </v-btn-toggle>
  </v-layout>
</template>

<script>
const clients = [
  {
    key: '',
    mister: 'M',
    miss: 'Mme'
  },
  {
    key: 'inoya',
    mister: 'Mr.',
    miss: 'Mme.'
  },
  {
    key: 'nuxe',
    mister: 'Mr.',
    miss: 'Mrs'
  },
  {
    key: 'sisley',
    mister: 'Mr',
    miss: 'Mme'
  }
]

export default {
  name: 'WzSelectGender',

  props: {
    gender: {
      required: true,
      validator: function (value) {
        return (value ? (
          value.toLowerCase() === 'm' ||
          value.toLowerCase() === 'mme' ||
          value.toLowerCase() === 'mr.' || // inoya & nuxe
          value.toLowerCase() === 'mme.' || // inoya
          value.toLowerCase() === 'mrs' || // nuxe
          value.toLowerCase() === 'mr' || // sisley
          value === '') : true
        )
      }
    },
    client: {
      type: String,
      required: false
    }
  },

  data () {
    return {
      genderModel: '',
      clientModel: {}
    }
  },

  created () {
    let clientFound = clients.find(c => c.key === this.client)
    if (clientFound) {
      this.clientModel = Object.assign({}, clientFound)
    } else {
      this.clientModel = Object.assign({}, clients[0])
    }
    this.genderModel = this.gender
  },

  methods: {
    updateGender (e) {
      this.genderModel = this.genderModel || ''
      this.$emit('update:gender', this.genderModel)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzSelectGender.vue